<template>
  <div id="faq-search-search" class="faq-search">
    <div class="faq-search-container">
      <div class="faq-search-wrap">
        <input
          type="text"
          name="faq-search"
          placeholder="חיפוש..."
          :value="search"
          @input="searchHandler"
        />
        <button>
          <i class="icon icon-search-white"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqSearch",
  props: ["search", "update-search"],
  data() {
    return {};
  },
  methods: {
    searchHandler(e) {
      this.$emit("update-search", e.target.value);
    },
  },
};
</script>
